export default {
  SECTION_WIDGET_EVENT_CALENDAR: {
    container: {
      cellWidth: {
        100: {
          allow: true,
          itemPerRow: 1,
        },
        66.67: {
          allow: true,
          itemPerRow: 1,
        },
        58.33: {
          allow: true,
          itemPerRow: 1,
        },
        50: {
          allow: true,
          itemPerRow: 1,
        },
        41.67: {
          allow: true,
          itemPerRow: 1,
        },
        33.33: {
          allow: true,
          itemPerRow: 1,
        },
        25: {
          allow: true,
          itemPerRow: 1,
        },
        20: {
          allow: true,
          itemPerRow: 1,
        },
        16.66: {
          allow: true,
          itemPerRow: 1,
        },
      },
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true,
          itemPerRow: 1,
        },
        66.67: {
          allow: true,
          itemPerRow: 1,
        },
        58.33: {
          allow: true,
          itemPerRow: 1,
        },
        50: {
          allow: true,
          itemPerRow: 1,
        },
        41.67: {
          allow: true,
          itemPerRow: 1,
        },
        33.33: {
          allow: true,
          itemPerRow: 1,
        },
        25: {
          allow: true,
          itemPerRow: 1,
        },
        20: {
          allow: true,
          itemPerRow: 1,
        },
        16.66: {
          allow: true,
          itemPerRow: 1,
        },
      },
    },
  },
};
